<script>
import compoment from '@/components/draggable/VipDefaultComponents/DVipEditor'
export default {
  name: 'DVipMobileEditor',
  extends: compoment
}
</script>
